import { useContext, useState, useEffect } from 'react';
import { CompareSettings } from './CompareSettings';
import Container from '@/components/layout/Container';
import Image from 'next/image';

export default function CompareAttributes({
  block,
  entryUid,
  onDesktop,
  position
}) {
  const compareSettings = useContext(CompareSettings);
  const { compare_attributes } = block;

  const [visibleProducts, setVisibleProducts] = useState([]);

  useEffect(() => {
    const tempArr = [];
    if (onDesktop) {
      compareSettings.desktopSelectors.forEach((selected) => {
        const matchingProduct = compare_attributes.products[selected.index];
        tempArr.push(matchingProduct);
      });
    } else {
      compareSettings.mobileSelectors.forEach((selected) => {
        const matchingProduct = compare_attributes.products[selected.index];
        tempArr.push(matchingProduct);
      });
    }

    setVisibleProducts(tempArr);
  }, [compareSettings, onDesktop, compare_attributes]);

  return (
    <section
      id={entryUid + '_' + position}
      data-name="compare-products-cards"
      className="pt-[24px] pb-[24px] lg:pt-[34px] lg:pb-[34px]"
    >
      <Container fullPage={false}>
        <div
          className={`${onDesktop ? 'preheading-r' : 'preheading-s'} pb-2 pl-3`}
        >
          {compare_attributes.row_title}
        </div>
        <div className="grid min-h-[200px] grid-cols-2 gap-x-[16px] sm:gap-x-[24px] lg:grid-cols-3 lg:gap-x-[32px]">
          {visibleProducts.map((product, index) => {
            return (
              <div
                key={index}
                className="border-dawn-grey-80 w-full border-t-2"
              >
                <div
                  className={`bg-[${compare_attributes.background_color}] mt-5 p-3 lg:mt-10`}
                >
                  <div>
                    <div className="sh12 mb-[11px]">Support</div>
                    <div className="flex w-full justify-between">
                      {[...Array(product.support).keys()].map((_, index) => {
                        return (
                          <div
                            key={index}
                            className="bg-parlor-green mx-px h-[6px] w-full"
                          ></div>
                        );
                      })}
                      {[...Array(5 - product.support).keys()].map(
                        (_, index) => {
                          return (
                            <div
                              key={index}
                              className="bg-dawn-grey-30 mx-px h-[6px] w-full"
                            ></div>
                          );
                        }
                      )}
                    </div>
                    <div className="sh12 mt-[23px] mb-[11px]">
                      Pressure Relief
                    </div>
                    <div className="flex w-full justify-between">
                      {[...Array(product.pressure_relief).keys()].map(
                        (_, index) => {
                          return (
                            <div
                              key={index}
                              className="bg-parlor-green-60 mx-px h-[6px] w-full"
                            ></div>
                          );
                        }
                      )}
                      {[...Array(4 - product.pressure_relief).keys()].map(
                        (_, index) => {
                          return (
                            <div
                              key={index}
                              className="bg-dawn-grey-30 mx-px h-[6px] w-full"
                            ></div>
                          );
                        }
                      )}
                    </div>
                    <div>
                      <div className="sh12 mt-[23px] mb-[11px]">Cooling</div>
                      <div className="flex">
                        {[...Array(product.cooling).keys()].map((_, index) => {
                          return (
                            <div key={index} className="pr-[2px]">
                              <Image
                                src={compare_attributes.cooling_icon.url}
                                alt={compare_attributes.cooling_icon.title.replace(
                                  /\.[^/.]+$/,
                                  ''
                                )}
                                width={24}
                                height={24}
                                sizes="24px"
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="pt-[6px]">
                      {product.text_sections.map((section, index) => {
                        return (
                          <div
                            key={index}
                            className={`pt-3 ${index + 1 !== product.text_sections.length ? 'border-dawn-grey-60 border-b pb-3' : ''}`}
                          >
                            <div className="sh12 pb-1">{section.title}</div>
                            <div className="h6">{section.description}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
